module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modern-upload-field', {
    attrs: {
      "label": _vm.label,
      "name": _vm.name,
      "value": _vm.value,
      "accept": "image/jpeg,image/png,image/webp,image/gif",
      "required": _vm.required,
      "uploading": _vm.uploading,
      "has-error": _vm.fileError || _vm.hasError,
      "error-message": _vm.errorMessage,
      "hint": "Choose image (.jpg, .png, .webp)"
    },
    on: {
      "file-selected": _vm.changeFileHandle
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90ea1488"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Forms/RacePhoto.vue
// module id = 1743
// module chunks = 2